import { call, put, select, take, takeLatest } from 'redux-saga/effects';
import { requestHandler } from './fetcher.saga';
import { getSelectedMenu } from '../selectors/global.selector';
import { RECEIVE_VARIABLE_SERVER } from '../constants/variableServer';
import { DEPLOY_PATCH_MENU } from '../constants/patchMenu';
import {
	RECEIVE_IMPORT_CONTEXT,
	PRE_BULK_IMPORT_PRODUCTS,
	RECEIVE_CATALOG_IMPORT_RESULT,
} from '../constants/catalogImport';

const ENTITY = 'product';
const GET_METHOD = 'GET';
const POST_METHOD = 'POST';

export function* watchCheckImportContext() {
	while (true) {
		// Deux déclencheurs, et le second n'est pas un confort : un déploiement
		// remplit la table `product`, donc `isEmpty` bascule côté serveur. Sans
		// lui, l'écran et la navigation restaient en mode « carte vierge »
		// jusqu'au prochain rechargement de page — bouton « Importer » au lieu
		// de « Ré-importer », modèle sans colonne ID, régime de validation qui
		// n'exige plus les identifiants — alors que le serveur, lui, refuse
		// déjà tout fichier qui n'en porte pas.
		//
		// `DEPLOY_PATCH_MENU` part une fois la réponse du serveur reçue, la
		// table est donc déjà remplie quand on redemande le contexte. On ne
		// regarde pas le détail de cette réponse : un déploiement vide ou en
		// échec relance une requête inutile mais inoffensive, là où trier les
		// cas ferait dépendre cet écran des formes de réponse d'un autre.
		yield take([RECEIVE_VARIABLE_SERVER, DEPLOY_PATCH_MENU]);
		const store = yield select();
		const id_menu = getSelectedMenu(store.entity.variableServer);
		if (!id_menu) {
			continue;
		}
		yield* fetchImportContext(id_menu);
	}
}

/**
 * Relit le contexte d'import d'une carte et le range dans le store.
 * @param {Number} id_menu
 */
function* fetchImportContext(id_menu) {
	const result = yield call(
		requestHandler,
		ENTITY,
		GET_METHOD,
		true,
		null,
		'/import-context',
		{ id_menu }
	);
	const context = (result && result.result && result.result.result) || {};
	yield put({
		type: RECEIVE_IMPORT_CONTEXT,
		isEmpty: !!context.isEmpty,
		isChild: !!context.isChild,
		isZone: !!context.isZone,
		isMasterReimport: !!context.isMasterReimport,
	});
}

export function* bulkImportProducts(action) {
	const result = yield call(
		requestHandler,
		ENTITY,
		POST_METHOD,
		true,
		{
			products: action.products,
			id_menu: action.id_menu,
			isMenu: action.isMenu,
			isModifier: action.isModifier,
			// Drapeau explicite, jamais déduit : le serveur ne vide une carte que
			// sur cette demande, et revérifie les conditions de son côté. Absent
			// plutôt que `false` quand l'utilisateur n'a rien demandé.
			...(action.wipeCatalog ? { wipeCatalog: true } : {}),
		},
		'/bulk-import'
	);
	const summary = result && result.result && result.result.result;
	// Un échec après une demande de suppression ne dit pas où en est la
	// carte : le serveur a pu la vider en partie. On relit son contexte
	// avant de relâcher l'écran, pour que celui-ci reparte de l'état réel.
	if (!summary && action.wipeCatalog) {
		yield* fetchImportContext(action.id_menu);
	}
	yield put({
		type: RECEIVE_CATALOG_IMPORT_RESULT,
		result: summary,
	});
}

export function* watchBulkImportProducts() {
	yield takeLatest(PRE_BULK_IMPORT_PRODUCTS, bulkImportProducts);
}
